import React, { useState } from "react";
import {
  TabList,
  Tab,
  SelectTabEvent,
  SelectTabData,
} from "@fluentui/react-components";
import {
  ChatRegular,
  TimelineRegular,
  TaskListSquareLtrRegular,
} from "@fluentui/react-icons";
import PlanPanelRight from "./PlanPanelRight";
import { PlanDetailsProps } from "../../models";
import "../../styles/PlanPanelRightTabs.css";

type TabValue = "status" | "room" | "trace";

const PlanPanelRightTabs: React.FC<PlanDetailsProps> = (props) => {
  const [selectedTab, setSelectedTab] = useState<TabValue>("status");

  const handleTabSelect = (event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value as TabValue);
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case "status":
        return <PlanPanelRight {...props} />;
      case "room":
        return (
          <div className="tab-placeholder">
            <ChatRegular className="tab-placeholder__icon" />
            <span className="tab-placeholder__text">Agent Room - Coming Soon</span>
          </div>
        );
      case "trace":
        return (
          <div className="tab-placeholder">
            <TimelineRegular className="tab-placeholder__icon" />
            <span className="tab-placeholder__text">Execution Trace - Coming Soon</span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="plan-panel-right-tabs">
      <TabList
        selectedValue={selectedTab}
        onTabSelect={handleTabSelect}
        className="plan-panel-right-tabs__tablist"
      >
        <Tab value="status" icon={<TaskListSquareLtrRegular />}>
          Status
        </Tab>
        <Tab value="room" icon={<ChatRegular />}>
          Room
        </Tab>
        <Tab value="trace" icon={<TimelineRegular />}>
          Trace
        </Tab>
      </TabList>
      <div className="plan-panel-right-tabs__content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default PlanPanelRightTabs;
